import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'environments/environment';

/**
 * Application-wide error handler.
 *
 * SOLE purpose (SD-7666): keep RAW uncaught error detail (the 500-class JS
 * errors that were not already handled) out of the PRODUCTION browser console —
 * an information-disclosure surface for end users, and the one thing SD-7544 was
 * actually meant to address. In local dev it echoes the full error so developers
 * can still debug.
 *
 * It shows NO user-facing growler and performs NO other side effects (no backend
 * reporting) — error/growler UX for end users is exactly what it was before
 * SD-7544. `handleError` is wrapped in try/catch so it can never itself throw.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler
{
    public handleError(error: unknown): void {
        try {
            // In production, swallow the raw error so it never reaches the
            // browser console. In dev, surface it for debugging.
            if (this.shouldSuppressConsole()) {
                return;
            }

            console.error(error);
        } catch {
            // Error handling must never throw — re-entering Angular's error
            // pipeline here could loop.
        }
    }

    /**
     * True only in an actual production build. A single indirection over the
     * static `environment` import so it can be stubbed in unit tests.
     */
    private shouldSuppressConsole(): boolean {
        return environment.production === true;
    }
}
